import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Sparkles, X } from "lucide-react";
import { fetchSubscription } from "../lib/api";
import { tr } from "../lib/i18n";
import { isNativeApp } from "../lib/native";

const KEY = "hv_trial_banner_dismissed";

// Owner-facing strip: Plus trial running (days left) or just ended. Dismiss hides it for the day.
export const TrialBanner = () => {
  const { data: sub } = useQuery({ queryKey: ["subscription"], queryFn: fetchSubscription });
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === new Date().toDateString());
  if (!sub || sub.plan !== "free" || hidden) return null;
  const ended = sub.trial_ended && sub.trial_ends_at && Date.now() - new Date(sub.trial_ends_at).getTime() < 7 * 86400_000;
  if (!sub.trial && !ended) return null;
  const dismiss = () => { sessionStorage.setItem(KEY, new Date().toDateString()); setHidden(true); };
  const d = sub.trial_days_left;
  return (
    <div data-testid="trial-banner" data-state={sub.trial ? "active" : "ended"} className={`mb-5 flex items-center gap-3 rounded-2xl border px-4 py-3 text-sm ${sub.trial ? "border-primary/30 bg-primary/5" : "border-border bg-card"}`}>
      <span className="h-8 w-8 shrink-0 rounded-xl bg-primary/10 text-primary grid place-items-center"><Sparkles className="h-4 w-4" /></span>
      <div className="flex-1 min-w-0">
        {sub.trial ? (
          <><b className="font-medium">{tr("Plus trial")} · {d} {tr(d === 1 ? "day left" : "days left")}.</b> <span className="text-muted-foreground">{tr("Unlimited documents, the Estate Library, tax & bereavement packs and reports are all unlocked.")}</span></>
        ) : (
          <><b className="font-medium">{tr("Your Plus trial has ended.")}</b> <span className="text-muted-foreground">{tr("You're on Free — everything you filed is still here; adding beyond 25 documents needs Plus.")}</span></>
        )}
      </div>
      {!isNativeApp() && <Link to="/pricing" data-testid="trial-banner-cta" className="shrink-0 rounded-full bg-primary text-primary-foreground px-3.5 py-1.5 text-xs font-medium hover:bg-primary/90">{sub.trial ? tr("Keep Plus") : tr("See plans")}</Link>}
      <button type="button" onClick={dismiss} data-testid="trial-banner-dismiss" aria-label={tr("Dismiss")} className="shrink-0 text-muted-foreground hover:text-foreground"><X className="h-4 w-4" /></button>
    </div>
  );
};
